import { combineReducers } from 'redux';
// import { blogReducer } from './blog';
import { bondsReducer } from './bonds';
import { commonReducer } from './common';
import { bondsDetailReducer } from './bondDetails';
import { adminBlogReducer } from "./admin/blog";
import { authenticateReducer } from './authenticate';
import { usersReducer } from './users';
import { accessFeaturesReducer } from './accessFeatures';
import { dashboardReducer } from './dashboard';
import { tradeBoardCastReducer } from './TradeBoardCast';
import { portfoliosReducer } from './portfolios';
import { discussionReducer } from './discussion';
import { adminRolesReducer } from './adminRoles';
import { adminPostReducer } from "./adminPost";
import { adminAnalyticsReducer } from './admin/analytics';
// import { moderationsReducer } from './admin/postModerate';
import { adminBondReducer } from './admin/bond';
import { adminUsersReducer } from './admin/users';
import { adsLinkReducer } from './admin/adsLink';
import { adminUserRoleReducer } from './admin/userRole';
import { adminPortfolioReducer } from './admin/portfolios';
import { adminSubscriptionReducer } from './admin/subscription';
import { adminSubscriptionPlanReducer } from './admin/subscriptionPlan';
import { adminPositionReducer } from './admin/position';
import { adminSearchFilterReducer } from './admin/searchFilter';
import { moderationsReducer } from './moderations';
const rootReducer = combineReducers({
  // blog: blogReducer,
  bonds: bondsReducer,
  common: commonReducer,
  bondsDetail: bondsDetailReducer,
  blog: adminBlogReducer,
  authenticate: authenticateReducer,
  users: usersReducer,
  accessFeatures: accessFeaturesReducer,
  dashboard: dashboardReducer,
  tradeBoardCast: tradeBoardCastReducer,
  portfolios: portfoliosReducer,
  discussion: discussionReducer,
  adminRoles: adminRolesReducer,
  adminPost: adminPostReducer,
  adminAnalytics: adminAnalyticsReducer,
  adminPostModerations: moderationsReducer,
  adminBonds: adminBondReducer,
  adminUsers: adminUsersReducer,
  adsLink: adsLinkReducer,
  adminUserRole: adminUserRoleReducer,
  adminPortfolio: adminPortfolioReducer,
  adminSubscription: adminSubscriptionReducer,
  adminSubscriptionPlan: adminSubscriptionPlanReducer,
  adminPosition: adminPositionReducer,
  adminSearchFilter: adminSearchFilterReducer,
   moderations: moderationsReducer,
  // Add other reducers here
});

export default rootReducer;